import { render, staticRenderFns } from "./Postfach_Message.vue?vue&type=template&id=c7745296&scoped=true"
import script from "./Postfach_Message.vue?vue&type=script&lang=js"
export * from "./Postfach_Message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7745296",
  null
  
)

export default component.exports